// extracted by mini-css-extract-plugin
export default {"graph":"AlertsDayNightChart_graph__703rb"};